import types from './types';

const setPodcast = podcast => ({
  type: types.SET_PODCAST,
  payload: {
    podcast,
  },
});

export default {
  setPodcast,
};
